/**
 * Auktioner är avstängda tills en administratör slår på dem i admin. Inget
 * slår på sig självt – målet på 200 unika besökare per dygn är bara en signal
 * som visas i admin när det är nått.
 */

import { useQuery } from "@tanstack/react-query";
import { getAuctionsEnabled } from "./auction-availability.functions";

/** Antal unika besökare per dygn vi vill se innan auktioner slås på publikt. */
export const AUCTION_TRAFFIC_GOAL = 200;

/**
 * Sant bara när administratören slagit på auktioner. False under SSR och tills
 * inställningen hämtats, så inget auktionsinnehåll blinkar förbi.
 */
export function useAuctionsEnabled(): boolean {
  const { data } = useQuery({
    queryKey: ["auctions-enabled"],
    queryFn: () => getAuctionsEnabled(),
    staleTime: 5 * 60 * 1000,
  });
  return data?.enabled === true;
}
